import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RoutingService } from '../../../services/routing.service';

@Component({
  selector: 'app-cancel-link',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './cancel-link.component.html',
  styleUrl: './cancel-link.component.scss',
})
export class CancelLinkComponent {
  /**
   * level to go back from activated-route
   */
  @Input() level = 1;

  /**
   * style-classes to add
   */
  @Input() styleClass = '';

  /**
   * tell parent cancel cancelled
   */
  @Output() cancelled = new EventEmitter();

  constructor(private routingService: RoutingService) {}

  /**
   * Cancels the current operation and navigates back to a previous state based on a specified level.
   * It emits a cancellation event and determines the navigation level using the routing service or falls back to the default level.
   *
   * @return {void} Does not return a value.
   */
  cancel(): void {
    const level = this.routingService.getCancelLevel() || this.level;
    this.cancelled.emit();
    if (level > 0) {
      this.routingService.navigateBack(level);
    }
  }
}
